import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import { TextInput } from "@/components/Forms"

export const BankDetailsFields: FC = () => {
  const { control } = useFormContext()

  return (
    <>
      <Controller
        name='swiftCode'
        control={control}
        render={({ field, fieldState: { error } }) => <TextInput field={field} label='SWIFT' error={error} />}
      />

      <Controller
        name='iban'
        control={control}
        render={({ field, fieldState: { error } }) => <TextInput field={field} label='IBAN' error={error} />}
      />

      <Box className='grid grid-cols-3 gap-6'>
        <Controller
          name='routingNumber'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput field={field} label='Transit/Routing Number' error={error} />
          )}
        />

        <Controller
          name='institutionNumber'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput field={field} label='Institution Number' error={error} />
          )}
        />

        <Controller
          name='accountNumber'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput field={field} label='Account Number' error={error} />
          )}
        />
      </Box>
    </>
  )
}
